import {pt2px} from '@/utils/converter'
import React from 'react'
import Image from 'next/image'
import 'yet-another-react-lightbox/styles.css'
import {useRouter} from 'next/router'
import { useTranslation } from 'next-i18next'

const formatImageUrl = (url: string | undefined) => {
  if (!url) return '/placeholder.png';
  
  // If it's already a full URL, return it
  if (url.startsWith('http')) return url;
  
  // Remove any leading slashes from the path
  const cleanPath = url.replace(/^\/+/, '');
  
  // Construct the CDN URL, ensuring no double slashes
  const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL?.replace(/\/+$/, '') || '';
  return `${cdnUrl}/${cleanPath}`;
};


  const useIsLargeDevice = (breakpoint: number) => {
  const [isLarge, setIsLarge] = React.useState(false);

    React.useEffect(() => {
      const checkSize = () => setIsLarge(window.innerWidth >= breakpoint);
      checkSize();
      window.addEventListener('resize', checkSize);
      return () => window.removeEventListener('resize', checkSize);
    }, [breakpoint]);

    return isLarge;
  };

interface NoteBookMobileProps {
  pages: any
  pages_predefined_texts: any
  pages_dedication_texts: any
  product: any
  cover_pages_predefined_texts: any
  cover_pages: any
  setStep: any
  setActiveOption: any
  childName: any
  dedicationImage: any
  imageSelected: any
  inputDedication?:any
  bookPageType?: any
  setPageTypeModal?: any
}

export default function NoteBookMobile({
  pages,
  pages_predefined_texts,
  product,
  pages_dedication_texts,
  cover_pages,
  cover_pages_predefined_texts,
  setStep,
  setActiveOption,
  childName,
  dedicationImage,
  imageSelected,
  inputDedication,
  bookPageType,
  setPageTypeModal
}: NoteBookMobileProps){
  const isLarge = useIsLargeDevice(1024);
  const modified_pages: any = []
  const [imageWidth, setImageWidth] = React.useState(0)
  const [open, setOpen] = React.useState(true)
  const {locale} = useRouter();
  const {t} = useTranslation('personalizeModal');

  const router = useRouter()
  const name =
    router.query.name != undefined ? (router.query.name as string) : ''
  const handleImageLoad = (event: any) => {
    const width = event.target.clientWidth
    setImageWidth(width)
  }
  const slides = [
    {
      type: 'custom-slide',
    },
  ]

  const [page, setPage] = React.useState(0)
  const [scrollPosition, setScrollPosition] = React.useState(0)

  const mobile_book_width =
    (document.getElementById('page-0')?.getBoundingClientRect().width ?? 0) + 25
  React.useEffect(() => {
    // Function to handle the scroll event on the 'mobile-book' div
    const handleScroll = () => {
      // Get the reference to the 'mobile-book' div
      const mobileBookDiv = document.getElementById('mobile-book')

      // Update the state with the current scrollLeft position of the 'mobile-book' div
      if (mobileBookDiv) {
        let new_page: number = Math.floor(
          mobileBookDiv.scrollLeft / mobile_book_width,
        )
        if (new_page != 0) {
          new_page *= -1
        }
        setPage(new_page)
        setScrollPosition(mobileBookDiv.scrollLeft)
      }
    }

    // Add event listener for the scroll event on the 'mobile-book' div
    const mobileBookDiv = document.getElementById('mobile-book')
    if (mobileBookDiv) {
      mobileBookDiv.addEventListener('scroll', handleScroll)
    }

    // Clean up the event listener when the component unmounts
    return () => {
      if (mobileBookDiv) {
        mobileBookDiv.removeEventListener('scroll', handleScroll)
      }
    }
  }, [mobile_book_width]) // Re-run if page width changes

  if (pages) {
    //Swap two elements
    for (let index = pages.length - 1; index >= 0; index--) {
      if ((index + 1) % 2 === 0) {
        continue
      }
      modified_pages.push(pages[index + 1], pages[index])
      slides.push(
        {type: 'custom-slide', ...pages[index + 1]},
        {type: 'custom-slide', ...pages[index]},
      )
    }

    //modified_pages.splice(modified_pages, 1)
    const getTextAlignment = (text_align: string) => {
      if (text_align == 'C') {
        return 'center'
      }
      if (text_align == 'R') {
        return 'right'
      }
      if (text_align == 'L') {
        return 'left'
      }
      return 'left'
    }

    const compareWithPage = bookPageType === 'english' ? '1' : '0';
    const comapreWithPageLast = bookPageType === 'english' ? '0' : '1';
    return (
      <div className='w-full'>
        <div className="space-y-12 flex w-full flex-col items-center justify-center mx-auto" id="mobile-book">
          {/*
           *<Lightbox
           *  open={open}
           *  close={() => setOpen(false)}
           *  slides={slides}
           *  render={{
           *    slide: (slide: any) =>
           *      slide.type === 'custom-slide' ? (
           *        <BookMobileLightBoxSlide
           *          slide={slide}
           *          pages_predefined_texts={pages_predefined_texts}
           *          pages_dedication_texts={pages_dedication_texts}
           *          inputDedication={inputDedication}
           *          imageWidth={imageWidth}
           *        />
           *      ) : undefined,
           *  }}
           */}

          <div className="relative max-w-[500px] start-cover" id="page-0">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == compareWithPage)[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == compareWithPage,
                  )[0]['dimensions'],
                )
                const imageBlock = !item.text
                const imageTop = `${(item.Y_coord / dimensions.height) * 74.4}%`;
                const imageLeft = isLarge ? `${(item.X_coord / dimensions.width)*81}%` : `${(item.X_coord / dimensions.width) * 75}%`;

                if (imageBlock) {
                        return (
                          <div
                            key={`image-${idx}`}
                            className="texts absolute z-[20]" //increase z-index for image to show on cover
                            style={{
                              top: imageTop,
                              left: imageLeft,
                              width: isLarge ? `${item.width_percent*1.1}%` : `${item.width_percent}%`,
                              maxWidth: item.max_width
                            }}
                          >
                            {dedicationImage && (
                              <img
                                src={dedicationImage}
                                alt="Child"
                                className="object-cover rounded-full"
                              />
                            )}
                          </div>
                        );
                      }

                      const wordCount = item.text.trim().split(/\s+/).length;
                      const fontBaseSize =
                        (imageWidth * item.font_size) / pt2px(dimensions.width) < 10
                          ? 12
                          : (imageWidth * item.font_size) / pt2px(dimensions.width);
                      const adjustedFontSize = wordCount > 2 ? fontBaseSize - 2 : fontBaseSize;
                      const adjustedTop =
                        wordCount > 2 ? `${item.Y_coord_percent - 1.2}%` : `${item.Y_coord_percent}%`;
                      const adjustedLineHeight = wordCount > 2 ? item.line_height - 0.3 : item.line_height;

                return (
                    <div
                      className="texts absolute"
                      key={idx}
                      id={item.X_coord_percent}
                      style={{
                        fontSize:adjustedFontSize,
                        textAlign: getTextAlignment(item.text_align),
                        width:
                          (imageWidth * item.max_width) / pt2px(dimensions.width),
                        top: adjustedTop,
                        lineHeight: adjustedLineHeight,
                        whiteSpace: 'pre-wrap',
                        left: isLarge ? `${item.X_coord_percent * 1.7}%` : `${item.X_coord_percent * 2}%`, // changes the left margin based on screen size
                        color: item.color,
                        fontFamily: item.font_face + ',sans-serif',
                        direction: bookPageType == 'english' ? 'ltr' : 'rtl',
                      }}
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    ></div>
                  )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover border-[1.5px] border-primary rounded-md p-1 lg:min-h-[700px] lg:min-w-[540px]"
              width={500}
              height={500}
              priority={true}
              onLoad={handleImageLoad}
              src={formatImageUrl(bookPageType === 'english' ? cover_pages[1] : cover_pages[0])}
              // src={'/images/notebook-cover.png'}
            />
          </div>
          {modified_pages?.reverse().map((page: any, index: number) => {
            if (index == 0) {
              return <></>
            }
            return (
              <>
              <div className={`relative max-w-[500px] ${index === 1 && bookPageType === null ? 'mt-4': ''}`} id={`page-${index}`} key={index}>
                {index === 1 && bookPageType === null ? (
                    <Image
                      key={index}
                      onLoad={handleImageLoad}
                      className={`w-full h-full object-cover rounded-md p-1 lg:min-h-[700px] lg:min-w-[540px] img-${index} ${bookPageType === null ? '' : 'border-[1.5px] border-primary'}`}
                      height={700}
                      width={500}
                      alt="img"
                      src={'/images/null-page-type.png'}
                    />
                  ) : (
                    <Image
                      key={index}
                      onLoad={handleImageLoad}
                      className={`block w-full mob-book-image img-${index} rounded-md ${bookPageType === null ? '' : 'border-[1.5px] border-primary'} lg:min-h-[700px] lg:min-w-[540px]`}
                      height={500}
                      width={500}
                      alt="img"
                      src={formatImageUrl(page)}
                    />
                  )}
                {pages_dedication_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.dedication_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_dedication_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.mob-book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                                pt2px(dimensions.width) <
                              10
                                ? 12
                                : (imageWidth * item.font_size) /
                                  pt2px(dimensions.width),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            whiteSpace: 'pre-wrap',
                            textAlign: getTextAlignment(item.text_align),
                            lineHeight: item.line_height,
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face + ',sans-serif',
                          }}>
                          {inputDedication.replace(
                            '{basmti}',
                            name ?? (locale === 'ar' ? product?.replace_name?.ar : product?.replace_name?.en),
                          )}
                        </div>
                      )
                    } else {
                      return <></>
                    }
                  })}
                {pages_predefined_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.predefined_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_predefined_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.mob-book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            //fontSize:
                            //(imageWidth * item.font_size) /
                            //pt2px(dimensions.width) <
                            //10
                            //? 12
                            //: (imageWidth * item.font_size) /
                            //pt2px(dimensions.width),

                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            textAlign: getTextAlignment(item.text_align),
                            lineHeight: item.line_height,
                            whiteSpace: 'pre-wrap',
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face + ',sans-serif',
                          }}
                          dangerouslySetInnerHTML={{__html: item.text}}></div>
                      )
                    } else {
                      return <></>
                    }
                  })}
                  {bookPageType === null && (
                    <>
                    <div className='absolute -top-6 left-1/2 -translate-x-1/2 bg-primary text-white text-center p-4 h-[52px] min-w-[75%] w-contain rounded-lg text-sm lg:hidden' onClick={()=>{
                      setStep('edit');
                      setActiveOption('pageType');
                    }}>
                      <p>{t('selectInnerPages')}</p>
                    </div>
                    <div className='hidden lg:block absolute -top-6 left-1/2 -translate-x-1/2 bg-primary text-white text-center p-4 h-[52px] min-w-[75%] w-contain rounded-lg text-sm' onClick={()=>{
                      setPageTypeModal(true);
                    }}>
                      <p>{t('selectInnerPages')}</p>
                    </div>
                    </>
                  )}
              </div>
              </>
            )
          })}

          <div className="relative max-w-[500px]" id={`page-${modified_pages.length + 1}`}>
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == comapreWithPageLast)[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == comapreWithPageLast,
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) /
                          pt2px(dimensions.width) <
                        10
                          ? 12
                          : (imageWidth * item.font_size) /
                            pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      left: item.X_coord_percent * 2 + '%',
                      whiteSpace: 'pre-wrap',
                      color: item.color,
                      fontFamily: item.font_face + ',sans-serif',
                    }}
                    dangerouslySetInnerHTML={{__html: item.text}}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover border-[1.5px] border-primary rounded-md p-1 lg:min-h-[700px] lg:min-w-[540px]"
              width={500}
              height={500}
              priority={true}
              onLoad={handleImageLoad}
              src={formatImageUrl(bookPageType === 'english' ? cover_pages[0] : cover_pages[1])}
            />
          </div>
        </div>
      </div>
    )
  }
  return <></>
}